import { CommonModule } from '@angular/common';
import { NgModule, Component, ChangeDetectionStrategy, HostBinding, ViewEncapsulation } from '@angular/core';
import { BaseDirective } from '../../../../base.directive';

@Component({
    selector: 'eui-overlay-footer',
    templateUrl: './eui-overlay-footer.component.html',
    styleUrls: ['../../styles/_index.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
})
export class EuiOverlayFooterComponent extends BaseDirective {

    @HostBinding('class')
    get cssClasses() {
        return [
            super.getCssClasses(`eui-overlay-footer`),
        ].join(' ').trim();
    }

    constructor (
    ) {
        super();
    }
}
